import { FC, JSX } from 'react';

export const ConditionalWrapper: FC<{
	condition: boolean;
	wrapper: (children?: JSX.Element) => JSX.Element;
	children: JSX.Element;
}> = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);
